import { IonCard, IonCardContent, IonCol, IonIcon, IonLabel, IonRow } from "@ionic/react";
import React from "react";
import { alertCircleOutline } from "ionicons/icons";

interface _Props {
    warning: string;
}

const CogginsWarningBanner: React.FC<_Props> = ({ warning }) => {
    return (
        <>
            <IonRow className="ion-justify-content-center">
                <IonCol sizeSm="12" sizeMd="12" className="m-0 p-0">
                    <IonCard color="warning" mode="md">
                        <IonCardContent
                            className="d-flex align-items-center"
                            style={{
                                color: "white",
                            }}>
                            <IonIcon
                                icon={alertCircleOutline}
                                style={{
                                    fontSize: "28px",
                                    minWidth: "28px",
                                    minHeight: "28px",
                                    width: "28px",
                                    height: "28px",
                                    marginRight: "8px",
                                    color: "white",
                                    flexShrink: 0,
                                }}
                            />
                            <IonLabel
                                id="cogginsWarningMsg"
                                className="ion-text-wrap font-weight-bold"
                                style={{
                                    color: "white",
                                    fontSize: "16px",
                                }}>
                                {warning}
                            </IonLabel>
                        </IonCardContent>
                    </IonCard>
                </IonCol>
            </IonRow>
        </>
    );
};

export default CogginsWarningBanner;
